import { Component, Input, OnChanges } from '@angular/core';
import { PortfolioType } from '@ddt-web/config';
import { ComponentData } from '@ddt-web/data-service';

@Component({
	selector: 'perf-performance-disclosure',
	templateUrl: './performance-disclosure.component.html',
	styleUrls: ['./performance-disclosure.component.scss']
})
export class PerformanceDisclosureComponent implements OnChanges {
	@Input() public data: ComponentData;

	public hasBlkModel: boolean = false;
	public hasCustomModel: boolean = false;

	public ngOnChanges(): void {
		if (this.data?.success) {
			this.setHasPortfolioTypeFlags();
		}
	}

	private setHasPortfolioTypeFlags(): void {
		this.hasBlkModel = false;
		this.hasCustomModel = false;
		this.data.portfolioData.forEach(portfolio => {
			if (portfolio && portfolio.field['portfolioType']) {
				if (portfolio.field['portfolioType'].rawValue === PortfolioType.PORTFOLIO) {
					this.hasCustomModel = true;
				}
				if (portfolio.field['portfolioType'].rawValue === PortfolioType.MODEL) {
					this.hasBlkModel = true;
				}
			}
		});
	}
}
